module.exports = __webpack_public_path__ + "assets/10e289b59221c4b91d8baef9f74d1a04.svg";